import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { AgentStats } from '@servicetitan/telecom-rtcs-client/dist/events/agent-events';

export type ServiceUserStats = {
  avgCallTime: number;
  lastActionAt: string;
  lastHandledAt: string;
  lastIdleAt: string;
  loginAt: string;
  missedSessions: number;
  offeredSessions: number;
  totalSessions: number;
};

export function userStatsFromAgentStats(stats: AgentStats): ServiceUserStats {
  return {
    avgCallTime: stats.averageSessionMs,
    lastActionAt: stats.lastActionTime,
    lastHandledAt: stats.lastHandledTime,
    lastIdleAt: stats.lastIdleTime,
    loginAt: stats.loginTime,
    missedSessions: stats.missedSessions,
    offeredSessions: stats.offeredSessions,
    totalSessions: stats.acceptedSessions,
  };
}

type ServiceUser = {
  id: string;
  contactCenterUserId?: string | null;
  email: string;
  name: string;
  username?: string | null;
  stats?: ServiceUserStats | null;
  canChangeStatus: boolean;
  available: boolean;
  availabilityState: string;
  wrapupTime?: number;
  status: UserSetAvailabilityStatus;
  capacity: number;
};

export default ServiceUser;
